import React from 'react';
import { AdminSidebar } from './AdminSidebar';
import { Breadcrumb, BreadcrumbItem } from '../ui/Breadcrumb';
import { UnifiedHeader } from './UnifiedHeader';
import { useAdminSidebarState } from '../../hooks/useAdminSidebarState';

interface AdminLayoutProps {
  children: React.ReactNode;
  title: string;
  breadcrumbs?: BreadcrumbItem[];
  showSidebar?: boolean;
  className?: string;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({
  children,
  title,
  breadcrumbs = [],
  showSidebar = true,
  className = ''
}) => {
  const { collapsed, toggle, sidebarPad } = useAdminSidebarState();
  const padClass = showSidebar ? sidebarPad : '';

  return (
    <div className="min-h-screen bg-surface-0">
      <UnifiedHeader currentPage={title} />

      <div className="pt-16 print:pt-0 flex">
        {showSidebar && (
          <div className="print:hidden">
            <AdminSidebar collapsed={collapsed} onToggleCollapsed={toggle} />
          </div>
        )}

        <div className={`flex-1 min-w-0 min-h-screen transition-[padding] duration-200 ${padClass} print:!pl-0 ${className}`}>
          <div className="p-4 sm:p-6 lg:p-8">
            {breadcrumbs.length > 0 && (
              <div className="mb-6 print:hidden">
                <Breadcrumb items={breadcrumbs} />
              </div>
            )}

            <div className="space-y-6">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { AdminLayout };
